import { IonPage } from '@ionic/react';
import { AppHeader, IconArrowLeft, IconButton } from '@mindly/ui-components';
import { PrivateRoutes } from '../../routes/navigation';
import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ProfilePersonalDataSuccessWidget } from '../../widgets';
import { authStateSelector } from '../../redux/auth/selector';
import { resetAuthState } from '../../redux/auth/reducer';
import { userSelector } from '../../redux/user/selector';
import { consultationsSelector } from '../../redux/consultations/selector';
import { useUser } from 'src/shared/hooks/useUser';
type NeedUpdatePersonalDataSuccessPageProps = RouteComponentProps;

export function NeedUpdatePersonalDataSuccessPage({ history }: NeedUpdatePersonalDataSuccessPageProps) {
  const authData = useSelector(authStateSelector);
  const user = useSelector(userSelector);
  const consultations = useSelector(consultationsSelector);
  const { redirectToOnboarding } = useUser();

  const dispatch = useDispatch();

  const handleSuccess = useCallback(async () => {
    if (authData.redirectTo) {
      history.push(authData.redirectTo);
    } else if (user) {
      const isRedirectToOnboarding = await redirectToOnboarding();
      if (isRedirectToOnboarding) return;
      history.push(
        consultations?.length && !(user.id !== authData.onBoardingUserId && authData.newOnBoardingAnswers)
          ? PrivateRoutes.CONSULTATION
          : PrivateRoutes.PSYCHOLOGIST_LIST
      );
    }
    dispatch(resetAuthState());
  }, [authData, user, consultations]);

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconButton
          icon={<IconArrowLeft />}
          onClick={() => history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_COUNTRY_OF_LIVING)}
        />
      </AppHeader>
      <ProfilePersonalDataSuccessWidget onSubmit={handleSuccess} />
    </IonPage>
  );
}
